import { Dispatch } from 'redux'
import requestCreateRoom from '../../../actions/bookingCalendar/room/requestCreateRoom'
import requestUpdateRoom from '../../../actions/bookingCalendar/room/requestUpdateRoom'
import { IFormValues } from './index'

export function onSubmitCreate(formName: string) {
  return function(values: IFormValues, dispatch: Dispatch) {
    dispatch(requestCreateRoom(values, formName))
  }
}

export function onSubmitUpdate(formName: string) {
  return function(values: IFormValues, dispatch: Dispatch, props) {
    dispatch(requestUpdateRoom(props.roomId, values, formName))
  }
}
